<template>
  <div class="text-center ma-2">
    <v-snackbar :value="snackbar" @input="onClose" :color="color">
      {{ text }}
      <v-btn  text @click="onClose">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Snackbars",
  props: ["text", "snackbar", "color"],
  data() {
    return {
      alert: true
    };
  },
  methods: {
    onClose() {
      this.$emit("classSnackbar");
    }
  }
};
</script>
